<div class="row-container">
  <qpoint-suggestlist
    [filterable]="false"
    [dropdownListClearable]="true"
    class="selector"
    [dropDownVariant]="dropDownVariant.DropDownList"
    textField="name"
    [value]="selectedPlantSignalId()"
    (valueChange)="onPlantChanged($event)"
    [data]="plantsWithRoutesSignal()"
    [valuePrimitive]="true"
    [popupSettings]="{ appendTo: 'component' }"
    style="padding-right: 4px;">
    <ng-template qpointSuggestlistValueTemplate let-item>
      <div>{{ item?.name }}</div>
    </ng-template>
  </qpoint-suggestlist>
  <ng-container *ngIf="mapModeState.modes?.length > 0">
    <qpoint-map-mode-selection></qpoint-map-mode-selection>
  </ng-container>
</div>
